import React, { useContext, useEffect, useState } from 'react';
import { CropImageContext } from '../../../Context/CropImageContext';
import { EditVariantFormContext } from '../../../Context/EditVariantFormContext';

function ProductImagePreview({ image }) {
    const [hoverOnImage, setHoverOnImage] = useState(false);
    const [visible, setVisible] = useState(false);

    const { productImages, setProductImages } = useContext(EditVariantFormContext);

    const { setImageToCrop, setModalOpen, setImageId } = useContext(CropImageContext);

    const handleDeleteImage = () => {
        let filteredList = productImages.filter(item => item.id !== image.id);
        setProductImages(filteredList);
    }

    const handleReplaceImage = async (e) => {
        setHoverOnImage(false);
        const file = e.target.files[0];
        setImageToCrop(file);
        setModalOpen(true);
        setImageId(image.id);
        e.target.value = null;
    }

    useEffect(() => {
        if(hoverOnImage) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [hoverOnImage]);

    const uniqueId = `replace-image-input-${image.id}`;

    return (
        <div 
            onMouseEnter={() => setHoverOnImage(true)} 
            onMouseLeave={() => setHoverOnImage(false)} 
            className='relative w-[140px] h-[140px] rounded-lg overflow-hidden'
        >
            <img className='w-full h-full object-cover' src={image.url} alt="" />

            <div className={`${visible ? 'opacity-100 visible' : 'opacity-0 invisible'} transition-all delay-100 ease-in-out w-full h-full bg-[#00000066] absolute top-0 left-0 items-center justify-center flex flex-col gap-2`}>
                <label htmlFor={uniqueId} className='select-none bg-[#FFFFFF] w-3/5 py-[6px] text-sm font-semibold rounded text-center cursor-pointer'>Replace</label>
                
                <button onClick={handleDeleteImage} className='select-none bg-[#FFFFFF] w-3/5 py-[6px] text-sm font-semibold rounded'>Delete</button>

                <input 
                    className='hidden' 
                    id={uniqueId} 
                    type="file" 
                    accept="image/*" 
                    onChange={handleReplaceImage} 
                />
            </div>
        </div>
    );
}

export default ProductImagePreview;
